import { useLocale } from "next-intl";

export const useAlgoliaLocale = () => {
  const locale = useLocale().substring(0, 2);
  // capital case
  const capitalCaseLocale =
    locale.charAt(0).toUpperCase() + locale.slice(1).toLowerCase();
  return capitalCaseLocale;
};
